<!-- eslint-disable vue/no-v-html -->
<template>
    <card-skeleton class-name="ma-0 pa-1 text-secondary-dark" :is-loading="isLoading">
        <v-card-title>
            {{ t('inquiry.inquiryMessage') }}
        </v-card-title>
        <v-card-text>
            <div class="text-size-xs" v-html="formattedBody"></div>
        </v-card-text>
    </card-skeleton>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import CardSkeleton from '@/features/common/components/CardSkeleton.vue';
import { IIssueDetailsBody } from '../../types';

const { t } = useI18n();

const props = defineProps<IIssueDetailsBody>();

const formattedBody = computed(() => {
    if (!props.body) return '';
    // escape HTML to prevent XSS, then replace newlines with <br/>
    const escaped = props.body
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    return escaped.replace(/\n/g, '<br/>');
});
</script>
